module.exports = __webpack_public_path__ + "datahub/img/chart.15fe45db.svg";